import { IColuna } from "app/types/IColuna";
import filter from "lodash/filter";
import indexOf from "lodash/indexOf";
import sortBy from "lodash/sortBy";
import * as R from "ramda";

export const traduzirOrdenarNomeColunaPesquisaProduto = ({nomeColuna, nomeGrid, nomeAcoesGrid}:{nomeColuna: string, codigoFilialOrcamento?: string, nomeGrid?: "PESQUISAR_PRODUTOS_ORCAMENTO", nomeAcoesGrid?: boolean}) => {

    const mapColunasPesquisarProdutos = {
        "Codigo": "Código",
        "Referencia": "Referência",
        "Descricao": "Descrição",
        "Unidade": "Unid.",
        "PrecoUnitario" : "Preço Unitário",
        "PrecoAVista": "Preço à Vista",
        "Markup-produto": "% Markup",
        "CodigoFabricante" : "Código Fabricante",
        "Fornecedor" : "Fornecedor",
        "Disponibilidade" : "Disponibilidade",
        "EstoqueFilial": "Estoque Filial",
        "EstoqueCD": "Estoque CD",
        "EstoqueOutraFilial": "Estoque Outras Filiais",
        "EstoqueTotal": "Estoque Total",
        "Classe" : "Classe",
        "Acoes": "Ações",
        "QuantidadeInserir": "Quantidade",
        "DataUltimaCompra": "Última Compra",
        "PercentualDescontoMaximoAvancado" : "Desconto Máximo",
        "PercentualBonificacaoMaximaAvancada" : "Bonificação",
        "Comprador": "Comprador", 
        "LocalFisico": "Local Físico",
        "Info" : nomeAcoesGrid ? "Informações" : "",
        "Modelo": "Modelo",
        "VendaMinima": "Venda Mínima", // 490958
    }

    const mapParaUsar = R.includes(nomeGrid, ["PESQUISAR_PRODUTOS_ORCAMENTO", null, undefined]) && mapColunasPesquisarProdutos

    return  nomeColuna in mapParaUsar && mapParaUsar[nomeColuna]
}

export const ordenarColunas = (colunas: IColuna[]) => {
    const ordenacao = [
        "Codigo",
        "Referencia",
        "Descricao",
        "Unidade",
        "PrecoUnitario" ,
        "PrecoAVista",
        "Markup-produto",
        "CodigoFabricante" ,
        "Fornecedor" ,
        "Disponibilidade" ,
        "EstoqueFilial",
        "EstoqueCD",
        "EstoqueOutraFilial",
        "EstoqueTotal",
        "Classe" ,
        "Acoes",
        "QuantidadeInserir",
        "DataUltimaCompra",
        "PercentualDescontoMaximoAvancado" ,
        "PercentualBonificacaoMaximaAvancada" ,
        "Comprador",
        "LocalFisico",
        "Modelo",
        "VendaMinima", // 490958
        "Info" ,
    ]

    const colunasOrdenadas = sortBy(colunas, (coluna) => indexOf(ordenacao, coluna.Nome))
    return filter(colunasOrdenadas, (coluna) => ordenacao.includes(coluna.Nome))

  }

// Compartilhado entre HeadersPesquisaProdutos e TabelaProdutosSelecionados para alinhar as mesmas colunas numéricas à direita.
export const COLUNAS_ALINHADAS_DIREITA_PESQUISA_PRODUTO = [
    "PrecoUnitario",
    "PrecoAVista",
    "Markup-produto",
    "EstoqueFilial",
    "EstoqueCD",
    "EstoqueOutraFilial",
    "EstoqueTotal",
    "QuantidadeInserir",
    "PercentualDescontoMaximoAvancado",
    "PercentualBonificacaoMaximaAvancada",
    "VendaMinima",
]

export type ContextoVisibilidadeColunasPesquisaProduto = {
  exibirColunaMarkup: boolean;
  exibirEstoqueOutrasFiliais: boolean;
  exibirEstoqueTotal: boolean;
  utilizaDescontoMaximoBonificacaoAvancados: boolean;
  exibirPrecoAVista?: boolean;
  exibirLocalFisico: boolean;
}

// Mapa base de visibilidade compartilhado entre GridItensPesquisaProdutos, HeadersPesquisaProdutos e
// TabelaProdutosSelecionados. Cada consumidor pode sobrescrever/adicionar entradas próprias (ex: Quantidade, Ações).
export const obterOcultarColunasBasePesquisaProduto = (contexto: ContextoVisibilidadeColunasPesquisaProduto): { [nomeColuna: string]: boolean } => ({
  "% Markup": !contexto.exibirColunaMarkup,
  "Estoque CD": !contexto.exibirEstoqueOutrasFiliais,
  "Estoque Outras Filiais": !contexto.exibirEstoqueOutrasFiliais,
  "Desconto Máximo": !contexto.utilizaDescontoMaximoBonificacaoAvancados,
  Bonificação: !contexto.utilizaDescontoMaximoBonificacaoAvancados,
  "Última Compra": !contexto.exibirColunaMarkup,
  Comprador: !contexto.exibirColunaMarkup,
  "Local Físico": !(!contexto.exibirColunaMarkup && contexto.exibirLocalFisico),
  "Estoque Total": !contexto.exibirEstoqueTotal,
  "Preço à Vista": !contexto.exibirPrecoAVista,
  "PrecoUnitarioAVista": !contexto.exibirPrecoAVista,
})
